import { useQuery } from "@tanstack/react-query";
import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";
import { sortByDate } from "@utils/sorters";

const endpoint:string = 'work-plans';

export function useGetAllWorkPlans(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetWorkPlan(id: number, params:any = {}) {
    return useGetOne({
        queryKey: [endpoint, id],
        transform: (data:any) => {
            data.tasks = sortTasks(data.tasks);
            return data;
        },
        ...params
    });
}

export function useCreateWorkPlan() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateWorkPlan({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteWorkPlan({id}) {
    return useDelete({queryKey: [endpoint, id]});
}

export function getBudget(tasks:any, mode:string) {
    if(!tasks) {
        return 0;
    }

    let budget = 0;

    // Whole (balanced) budget
    if(mode == 'estimated_budget' || mode == 'actual_budget')
    {
        for(const task of tasks)
        {
            let amount = parseFloat(task[mode]);
            if(isNaN(amount)) {
                amount = 0;
            }
            // 1 == Income, 0 == Expense
            if(task['budget_type'] == 1)
            {
                budget += amount;
            }
            else
            {
                budget -= amount;
            }
        }

        return budget;
    }

    // Portion of a budget
    var isEstimated = mode.includes('estimated');
    var isIncome = mode.includes('income');

    for(const task of tasks)
    {
        // 1 == Income, 0 == Expense
        if((task['budget_type'] == 1 && isIncome) || (task['budget_type'] == 0 && !isIncome))
        {
            let amount = parseFloat(task[(isEstimated ? 'estimated' : 'actual')+'_budget']);
            if(isNaN(amount)) {
                amount = 0;
            }
            budget += amount;
        }
    }

    return budget;
};

export function sortTasks(tasks:any) {
    return tasks.sort((a, b) => {
        return sortByDate(a, b, 'due_date', 'asc');
    });
}
